import React, { useMemo } from 'react';
import { Link } from './skipLinkStyles';

export const SkipLink = () => {
    return useMemo(() => <Link href={`#main`} className={`skipLink`}>Skip to Content</Link>, []);
};

export default SkipLink;
